/**
 * Creates a throttled version of a function.

 * @param {Function} func - The function to throttle.
 * @param {number} wait - The number of milliseconds to delay.

 * @returns {Function} A throttled version of the provided function.
 *
 * @example
 * const throttledLog = throttle(1000, function() {
 *   console.log('Executed after delay');
 * });
 *
 * This will only call the function every 1000ms, even though
 * it might be invoked multiple times in rapid succession.
 */

export function throttle(wait, func) {
  let timerFlag = null;

  return function throttledFunction(...args) {
    const context = this;
    if (timerFlag === null) {
      func.apply(context, args);
      timerFlag = setTimeout(() => {
        timerFlag = null;
      }, wait);
    }
  }
}
